import { ADD_CSV_PROCESSING_RESULT, CLEAR_CSV_PROCESSING_RESULTS, INITIALIZE_CSV_PROCESSING_RESULTS } from '../constants/actionTypes';

const initialState = {
    results: [],
    totalCount: 0
};

export const csvProcessingResults = (state = initialState, action) => {
    switch(action.type) {
        case INITIALIZE_CSV_PROCESSING_RESULTS:
            return {
                ...state,
                totalCount: action.totalCount
            };

        case ADD_CSV_PROCESSING_RESULT:
            return {
                ...state,
                results: [...state.results, action.result]
            };
        
        case CLEAR_CSV_PROCESSING_RESULTS:
            return initialState;
        
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/csvProcessingResults.js